import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      monthly: false,
      complaints: false,
      departmentsStatus: false,
      bestSubjects: false,
      brandsStatus: false,
      locationPerformance: false,
    },
    dashboardData: {
      counters: {
        resolved: {
          ytd: 0,
          mtd: 0,
        },
        followUp: 0,
        waitingForApproval: 0,
        pending: {
          count: 0,
          duration: '',
        },
        answerAvg: '',
        solutionAvg: '',
      },
      monthly: {
        series: [],
        categories: [],
        unresolved: {
          lastYear: [],
          thisYear: [],
        },
      },
      complaints: {
        series: [],
        categories: [],
        colors: [],
      },
      departmentsStatus: {
        series: [],
        categories: [],
        colors: [],
      },
      bestSubjects: {
        series: [],
        categories: [],
        colors: [],
      },
      brandsStatus: {
        series: [],
        categories: [],
        colors: [],
      },
      locationPerformance: {
        data: [],
        grandTotals: {
          csi_sales: 0,
          csi_sales_rates: 0,
          csi_services: 0,
          csi_services_rates: 0,
          google_score: 0,
          google_score_rates: 0,
        },
      },
    },
    filterParams: {
      bestSubjects: {
        id_com_brand: null,
      },
    },
    filterData: {
      brands: [],
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
    filterParams(state) {
      return state.filterParams
    },
    filterData(state) {
      return state.filterData
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'monthly') {
        state.loadings.monthly = data.status
      }
      if (data.type === 'complaints') {
        state.loadings.complaints = data.status
      }
      if (data.type === 'departmentsStatus') {
        state.loadings.departmentsStatus = data.status
      }
      if (data.type === 'bestSubjects') {
        state.loadings.bestSubjects = data.status
      }
      if (data.type === 'brandsStatus') {
        state.loadings.brandsStatus = data.status
      }
      if (data.type === 'locationPerformance') {
        state.loadings.locationPerformance = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'monthly') {
        state.dashboardData.monthly = data.data
      }
      if (data.type === 'complaints') {
        state.dashboardData.complaints = data.data
      }
      if (data.type === 'departmentsStatus') {
        state.dashboardData.departmentsStatus = data.data
      }
      if (data.type === 'bestSubjects') {
        state.dashboardData.bestSubjects = data.data
      }
      if (data.type === 'brandsStatus') {
        state.dashboardData.brandsStatus = data.data
      }
      if (data.type === 'locationPerformance') {
        state.dashboardData.locationPerformance = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    SET_FILTER_DATA(state, data) {
      state.filterData = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          resolved: {
            ytd: 0,
            mtd: 0,
          },
          followUp: 0,
          waitingForApproval: 0,
          pending: {
            count: 0,
            duration: {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            },
          },
          answerAvg: {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          },
          solutionAvg: {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          },
        },
        monthly: {
          series: [],
          categories: [],
          unresolved: {
            lastYear: [],
            thisYear: [],
          },
        },
        complaints: {
          series: [],
          categories: [],
          colors: [],
        },
        departmentsStatus: {
          series: [],
          categories: [],
          colors: [],
        },
        bestSubjects: {
          series: [],
          categories: [],
          colors: [],
        },
        brandsStatus: {
          series: [],
          categories: [],
          colors: [],
        },
        locationPerformance: {
          data: [],
          grandTotals: {
            csi_sales: 0,
            csi_sales_rates: 0,
            csi_services: 0,
            csi_services_rates: 0,
            google_score: 0,
            google_score_rates: 0,
          },
        },
      }
    },
  },
  actions: {
    getFilterData({ commit }) {
      axiosIns
        .post(`${ROOT_URL}/crmLiveFilters`)
        .then(response => {
          commit('SET_FILTER_DATA', response.data)
        })
        .catch(error => console.error(error))
    },
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      if (params.id_com_brand === null) {
        // eslint-disable-next-line no-param-reassign
        delete params.id_com_brand
      }
      const paramsData = new URLSearchParams(params).toString()
      axiosIns
        .post(`${ROOT_URL}/crmLive?${paramsData}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      if (params.id_com_brand === null) {
        // eslint-disable-next-line no-param-reassign
        delete params.id_com_brand
      }
      const paramsData = new URLSearchParams(params).toString()
      axiosIns
        .post(`${ROOT_URL}/crmLive?${paramsData}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
